import { DayPicker, type DayPickerProps } from "react-day-picker";
import "react-day-picker/style.css";
import { es } from "date-fns/locale";
import { cn } from "@/lib/utils";

export function Calendar({ className, ...props }: DayPickerProps) {
  return (
    <DayPicker
      locale={es}
      showOutsideDays
      className={cn("p-2", className)}
      {...props}
    />
  );
}
